module.exports = __webpack_public_path__ + "static/img/kejiguan.753402a.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kejiguan.jpeg
// module id = /h7T
// module chunks = 1